"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textInputStyles = void 0;
const styled_components_1 = require("styled-components");
exports.textInputStyles = (0, styled_components_1.css) `
  textarea::placeholder,
  input::placeholder {
    ${({ theme }) => theme.typography.variants.primary.main};
    color: ${({ theme }) => theme.palette.gray[60]};
    opacity: 1;
  }

  .MuiFormHelperText-root {
    font-size: ${({ theme }) => theme.typography.Size.Small};

    &.Mui-error {
      color: ${({ theme }) => theme.palette.status.error};
    }
  }

  .MuiOutlinedInput-root {
    border-radius: ${({ theme }) => theme.constants.borderRadius};
    transition: 0.2s ease all;

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.primary.main};
    }

    &.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.status.error};
    }
  }

  .MuiOutlinedInput-input {
    padding: 16px;
  }

  .MuiOutlinedInput-multiline {
    padding: 0;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.gray[40]};
    transition: 0.2s ease all;

    &:hover {
      border-color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    background-color: transparent;
    border-width: 1px;
  }

  &:hover .MuiOutlinedInput-root {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`;
//# sourceMappingURL=styles.js.map